/**
 * Created by zzy on 2019/8/6.
 */
import CameraStatistics from './CameraArchiveStatistics.vue'
export default CameraStatistics



// WEBPACK FOOTER //
// ./src/views/statistics/cameraArchiveStatistics/index.js